export default __webpack_public_path__ + "2c6b41bc035c6ebb6a30028759f5ac09.png";